import { render, staticRenderFns } from "./VendorUnitsList.vue?vue&type=template&id=7437f8d5&scoped=true&"
import script from "./VendorUnitsList.vue?vue&type=script&lang=js&"
export * from "./VendorUnitsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7437f8d5",
  null
  
)

export default component.exports